/* Copyright (c) 2017-2022 VMware, Inc. All rights reserved. VMware Confidential */

import { Component, Input } from "@angular/core";
import { BaseDialog } from "../base-dialog";

// @formatter:off
@Component({
    selector: 'dr-message-dialog',
    templateUrl: 'message-dialog.html',
    styleUrls: ['message-dialog.scss']
})
// @formatter:on

export class MessageDialog extends BaseDialog {
    @Input() title: string;
    @Input() message: string;
    @Input() iconShape: string;
    @Input() confirmationBtnText: string = "dialog.button.Ok";
    @Input() confirmationBtnStyle: string = "btn-primary";
    @Input() innerHTML: boolean = false;
    @Input() messageParams: any[] = [];
    @Input() titleParams: any[] = [];
}
